import {
  faCaretDown,
  faCaretUp,
  faLock,
  faLockOpen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  lockSingleHerbList,
  singleHerbTotalChange,
} from "../../actions/formulaAction";
import HerbItem from "../HerbItem";
import { getUserDetail } from "../../utils/helper";
const SingleHerbList = ({
  rawGramPerDayBeforeConversion,
  isRawType,
  singleHerbList,
  isOuterLocked,
  fromFormula = false,
  totalPacket = 1,
}) => {
  const singleHerbTotal = useSelector(
    (state) => state.formula.present.singleHerbTotal
  );
  const isLocked = useSelector(
    (state) => state.formula.present.singleHerbLocked
  );

  const [canEditPercentage, setCanEditPercentage] = useState(false);
  const [isTotalChanged, setIsTotalChanged] = useState(false);
  const [totalDosage, setTotalDosage] = useState(singleHerbTotal.totalDosage);
  const dispatch = useDispatch();
  const isAllowed = getUserDetail()?.practitioner_status == 1;
  useEffect(() => {
    if (isOuterLocked) {
      dispatch(lockSingleHerbList(false));
    }
  }, [isOuterLocked, dispatch]);

  useEffect(() => {
    let herbGreaterThanZero = singleHerbList.filter((x) => x.dosage > 0);

    setCanEditPercentage(herbGreaterThanZero.length >= 2);
    setIsTotalChanged(true);
    setTotalDosage(singleHerbTotal.totalDosage);
  }, [singleHerbTotal.totalDosage]);

  return (
    <>
      {singleHerbList.length > 0 ? (
        <div className="item-wrapper">
          <div style={{ width: "30px" }}></div>
          <div
            className={`single-herb-section mt-2 ${isLocked ? "locked" : ""}`}
          >
            <table className="table">
              <thead>
                <tr className="head">
                  <th></th>
                  <th>SINGLE HERBS</th>
                  <th className="text-right pr-5">DOSAGE (G)</th>
                  <th className="text-right">DOSAGE (%)</th>
                  {!isRawType && <th className="text-right">HERB RATIO</th>}
                  {isAllowed && <th className="text-right">PRICE</th>}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {singleHerbList.map((herb, index) => (
                  <HerbItem
                    canEditPercentage={canEditPercentage}
                    rawGramPerDayBeforeConversion={
                      rawGramPerDayBeforeConversion
                    }
                    herb={herb}
                    isLocked={isLocked || isOuterLocked}
                    isOuterLocked={isOuterLocked}
                    key={herb.id}
                    totalDosage={singleHerbTotal.totalDosage}
                    formulaId={0}
                    isRawType={isRawType}
                    firstItem={index === 0}
                    lastItem={index === singleHerbList.length - 1}
                    fromFormula={fromFormula}
                    totalPacket={totalPacket}
                  />
                ))}
                <tr className="total-section">
                  <td></td>
                  <td>TOTAL SERVINGS:</td>
                  <td className={`text-right pr-5`}>
                    {true ? (
                      `${singleHerbTotal.totalDosage.toLocaleString("en-US", {
                        maximumFractionDigits: 1,
                        minimumFractionDigits: 1,
                      })} grams`
                    ) : (
                      <div
                        className={`d-flex align-items-center justify-content-end mr-1 ${
                          isOuterLocked && "outer-locked"
                        }`}
                      >
                        <button
                          className={`lock-btn ${isLocked && "locked"} ${
                            isOuterLocked && "outer-locked"
                          }`}
                          type="button"
                          disabled={isOuterLocked}
                          onClick={() => {
                            dispatch(lockSingleHerbList(!isLocked));
                          }}
                        >
                          <FontAwesomeIcon
                            icon={isLocked ? faLock : faLockOpen}
                          />
                        </button>
                        <div
                          className={` number-field mr-2  ${
                            isLocked && "outer-locked"
                          }`}
                        >
                          <input
                            type="number"
                            min="0"
                            step="any"
                            value={totalDosage}
                            onChange={(e) => setTotalDosage(e.target.value)}
                            onBlur={(e) =>
                              dispatch(
                                singleHerbTotalChange(
                                  parseFloat(e.target.value)
                                )
                              )
                            }
                          />
                          <div>
                            <div
                              className="icon"
                              onClick={() => {
                                dispatch(
                                  singleHerbTotalChange(
                                    singleHerbTotal.totalDosage +
                                      (isTotalChanged ? 0.5 : 1)
                                  )
                                );
                                setIsTotalChanged(false);
                              }}
                            >
                              <FontAwesomeIcon icon={faCaretUp} />
                            </div>
                            <div
                              className="icon"
                              onClick={() => {
                                parseFloat(singleHerbTotal.totalDosage) > 0
                                  ? dispatch(
                                      singleHerbTotalChange(
                                        singleHerbTotal.totalDosage -
                                          (isTotalChanged ? 0.5 : 1)
                                      )
                                    )
                                  : dispatch(singleHerbTotalChange(0));
                                setIsTotalChanged(false);
                              }}
                            >
                              <FontAwesomeIcon icon={faCaretDown} />
                            </div>
                          </div>
                        </div>
                        grams
                      </div>
                    )}
                  </td>
                  <td></td>
                  {!isRawType && <td></td>}
                  {isAllowed && (
                    <td className="text-right">
                      {singleHerbTotal.totalPrice.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                        style: "currency",
                        currency: "USD",
                      })}
                    </td>
                  )}
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default SingleHerbList;
